import {
  alertPanel_warningBorder,
  base_colorContentBorder,
  notification_colorAlert,
  tag_colorTagBlueBackground,
  tag_colorTagBlueText,
  tag_colorTagNewBackground,
  tag_colorTagNewText,
  tag_colorTagPendingBackground,
  tag_colorTagPendingText,
  tag_colorTagSevereBackground,
} from 'ext-ui/style/colors'
import { cornerRadius, spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${spacing(3)};
  padding: ${spacing(4)} ${spacing(5)};
  border-radius: ${cornerRadius};
  border: 1px solid ${base_colorContentBorder};

  &.topAlign {
    align-items: flex-start;
  }

  .AlertBanner-icon {
    display: flex;
    // prevent the icon getting squished when the rejection note is long
    flex-shrink: 0;
  }

  .AlertBanner-chevron {
    display: flex;
    // prevent the icon getting squished when the rejection note is long
    flex-shrink: 0;
    cursor: pointer;
  }

  .collapsible {
    margin-top: ${spacing(2)};
  }

  &.noTitle .collapsible {
    margin-top: 0;
  }

  // VARIANTS
  &.soft {
    background-color: ${tag_colorTagBlueBackground};
    .AlertBanner-chevron > path {
      fill: ${tag_colorTagBlueText};
    }
  }

  &.warning {
    background-color: ${tag_colorTagPendingBackground};
    color: ${tag_colorTagPendingText};
    border: 1px solid ${alertPanel_warningBorder};
    .AlertBanner-chevron > path {
      fill: ${tag_colorTagPendingText};
    }
  }

  &.severe {
    background-color: ${tag_colorTagSevereBackground};
    .AlertBanner-chevron > path {
      fill: ${notification_colorAlert};
    }
  }

  &.new {
    background-color: ${tag_colorTagNewBackground};
    .AlertBanner-chevron > path {
      fill: ${tag_colorTagNewText};
    }
  }
`
